import { render, staticRenderFns } from "./MenuSender.vue?vue&type=template&id=119d3564&scoped=true&"
import script from "./MenuSender.vue?vue&type=script&lang=js&"
export * from "./MenuSender.vue?vue&type=script&lang=js&"
import style0 from "./MenuSender.vue?vue&type=style&index=0&id=119d3564&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119d3564",
  null
  
)

export default component.exports